export type ClaimStatus = 'submitted' | 'processing' | 'paid' | 'rejected' | 'queried';

export interface InsuranceProvider {
  id: string;
  name: string;
  code: string;
  claimsEmail: string;
  preAuthPhone: string;
  notes: string;
  active: boolean;
}

export interface Claim {
  id: string;
  invoiceId: string;
  invoiceNumber: string;
  patientId: string;
  patientName: string;
  providerId: string;
  providerName: string;
  amountClaimed: number;
  amountPaid: number | null;
  status: ClaimStatus;
  referenceNumber: string;
  rejectionReason: string;
  resubmissionCount: number;
  notes: string;
  submittedAt: string;
  paidAt?: string;
  rejectedAt?: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
}

export interface ClaimsDashboard {
  providers: ProviderSummary[];
  totals: { claimed: number; paid: number; outstanding: number; rejected: number; count: number };
}

export interface ProviderSummary {
  providerId: string;
  providerName: string;
  claimed: number;
  paid: number;
  outstanding: number;
  rejected: number;
  count: number;
  rejectionCount: number;
  rejectionRate: number;
}

export const CLAIM_STATUS_LABELS: Record<ClaimStatus, string> = {
  submitted: 'Submitted',
  processing: 'Processing',
  paid: 'Paid',
  rejected: 'Rejected',
  queried: 'Queried',
};

export const CLAIM_STATUS_COLORS: Record<ClaimStatus, string> = {
  submitted: 'bg-blue-100 text-blue-700',
  processing: 'bg-yellow-100 text-yellow-700',
  paid: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  queried: 'bg-orange-100 text-orange-700',
};
